import { ButtonProps } from "@chakra-ui/react";

import { ExportButton } from "@/common/components/ExportButton";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import { API_URL } from "@/common/utils/env";
import { CompaniesSearchBody } from "@reflag/shared/companyAPI";

interface ExportCompaniesButtonProps extends Omit<ButtonProps, "onClick"> {
  exportParams: CompaniesSearchBody;
}

export function ExportCompaniesButton({
  exportParams,
}: ExportCompaniesButtonProps) {
  const { appId, envId } = useEnvironment();

  const formFields = {
    filter: exportParams.filter,
    idNameFilter: exportParams.idNameFilter,
    sortBy: exportParams.sortBy,
    sortOrder: exportParams.sortOrder,
    includeDetailsForFeatureIds: exportParams.includeDetailsForFeatureIds,
    columns: exportParams.columns,
  };

  const exportUrl = `${API_URL}/apps/${appId}/companies/export?envId=${envId}`;

  return <ExportButton exportUrl={exportUrl} formFields={formFields} />;
}
